import { render, staticRenderFns } from "./starshop-transactions.vue?vue&type=template&id=a395a34a"
import script from "./starshop-transactions.vue?vue&type=script&lang=js"
export * from "./starshop-transactions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports